import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white gap-3 py-4" }
const _hoisted_2 = { class: "flex flex-col px-5" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "text-lg font-semibold text-black" }
const _hoisted_5 = { class: "flex flex-row w-[100%]" }
const _hoisted_6 = { class: "w-full mb-2 border-b border-b-gray-200" }
const _hoisted_7 = { class: "flex gap-2 mt-1 px-5" }
const _hoisted_8 = { class: "child-wrapper px-5" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onSubmit"]
const _hoisted_11 = { class: "form-group flex justify-between items-center" }
const _hoisted_12 = {
  for: "firstName",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_13 = { class: "form-group flex justify-between items-center" }
const _hoisted_14 = {
  for: "lastName",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_15 = { class: "form-group flex justify-between items-center" }
const _hoisted_16 = {
  for: "email",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_17 = { class: "flex flex-col gap-1 w-[60%]" }
const _hoisted_18 = {
  key: 0,
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_19 = {
  key: 1,
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_20 = { class: "form-group flex justify-between items-center" }
const _hoisted_21 = {
  for: "password",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_22 = { class: "flex flex-col gap-1 w-[60%]" }
const _hoisted_23 = {
  key: 0,
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_24 = { class: "form-group flex justify-between items-center" }
const _hoisted_25 = {
  for: "studentNumber",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["onSubmit"]
const _hoisted_28 = { class: "form-group flex justify-between items-center border-b-2 border-gray-200 pb-4" }
const _hoisted_29 = {
  for: "grade",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_30 = {
  key: 0,
  class: "form-group flex justify-between items-center border-b-2 border-gray-200 pb-4"
}
const _hoisted_31 = {
  for: "lockedJourneys",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "active" }, "Active", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "deactivated" }, "Deactivated", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "archived" }, "Archived", -1)
const _hoisted_35 = [
  _hoisted_32,
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "form-group flex justify-between items-center border-b-2 border-gray-200 pb-4"
}
const _hoisted_37 = {
  for: "lockedJourneys",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_38 = { value: "catchup" }
const _hoisted_39 = { value: "assessment" }
const _hoisted_40 = { value: "none" }
const _hoisted_41 = { class: "form-group flex justify-between items-center border-b-2 border-gray-200 pb-4" }
const _hoisted_42 = {
  for: "country",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_43 = { key: 2 }
const _hoisted_44 = ["onSubmit"]
const _hoisted_45 = { class: "flex flex-row gap-3 justify-between" }
const _hoisted_46 = { class: "text-sm font-medium text-gray-700 mb-3" }
const _hoisted_47 = { class: "form-group flex justify-between gap-3 flex-col w-[60%]" }
const _hoisted_48 = { class: "form-group flex justify-between items-center" }
const _hoisted_49 = ["for"]
const _hoisted_50 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  key: 0,
  class: "form-group flex justify-between items-center"
}
const _hoisted_53 = {
  for: "assessmentLevel",
  class: "text-sm font-medium text-[#344054]"
}
const _hoisted_54 = ["value"]
const _hoisted_55 = {
  key: 1,
  class: "ml-auto text-sm font-medium text-[#344054] -mt-3 -mb-2"
}
const _hoisted_56 = { class: "form-group flex justify-between items-center" }
const _hoisted_57 = {
  for: "grade",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: "en-ZA" }, "English ZA", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("option", { value: "en-GB" }, "English GB", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("option", { value: "en-AU" }, "English AU", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("option", { value: "af-ZA" }, "Afrikaans", -1)
const _hoisted_62 = [
  _hoisted_58,
  _hoisted_59,
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = { class: "w-full flex flex-col gap-3 items-center justify-center mt-2 px-5" }
const _hoisted_64 = { class: "w-full flex gap-4" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { class: "relative sm:my-8 p-3" }
const _hoisted_69 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_70 = { class: "flex flex-col items-center px-12 py-8" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = {
  key: 0,
  class: "mt-5 font-medium text-xl text-gray-900"
}
const _hoisted_74 = {
  key: 1,
  class: "mt-5 font-medium text-xl text-gray-900"
}
const _hoisted_75 = {
  key: 2,
  class: "font-normal text-sm text-gray-400 mt-2 text-center"
}
const _hoisted_76 = { class: "font-medium" }
const _hoisted_77 = {
  key: 3,
  class: "font-normal text-sm text-gray-400 mt-2 text-center"
}
const _hoisted_78 = { class: "font-medium" }
const _hoisted_79 = { class: "mt-8 flex gap-4 text-base w-full" }

import {
  computed,
  onMounted,
  ref,
} from "vue";
import { useLearnerStore } from "@/stores/learnerStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { useFilterStore } from "@/stores/filterStore";
import { useLicenseStore } from "@/stores/licenseStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useUserStore } from "@/stores/userStore";
import SchoolLicenseComponent from "@/components/global/SchoolLicenseComponent.vue";

// Define the props that the component accepts

export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateLearnerComponent',
  props: {
  gradeLevel: {
    type: Number,
    default: 0,
    required: false,
  },
  preferredLanguage: {
    type: String,
    default: "en-ZA",
    required: false,
  },
  subject: {
    type: String,
    default: "",
    required: false,
  },
  classId: {
    type: String,
    default: "",
    required: false,
  },
  selectedStudents: {
    type: Array,
    required: false,
  },
},
  emits: ["closeUpdate"],
  setup(__props, { emit }) {

const props = __props;



// Initialize the stores for learners, school, and subjects
const learnerStore = useLearnerStore();
const schoolStore = useSchoolStore();
const filterStore = useFilterStore();
const licenseStore = useLicenseStore();
const subjectStore = useSubjectStore();
const userStore = useUserStore();

// Initialize reactive references
const selectedStudents = ref<string[]>([]);
const singleEdit = ref(true);
const selectedJourney = ref("");
const selectedEnglishClass = ref("");
const selectedMathsClass = ref("");
const activeTab = ref("personal");
const initialFormData = ref({} as any);
const showEditComplete = ref(false);
const disabledBtn = ref(false);
const response = ref("");
const validpassword = ref(false);
const validEmail = ref(true);
const validEmailExists = ref(false);
const lockedJourneys = ref({
  assessment: false,
  catchup: false,
});

//Initialize selectedStudents with the passed prop
selectedStudents.value = props.selectedStudents as string[];

// Compute the form data for the learner
const formData = computed(() => {
  // Getting the learner details from the store
  const learnerDetails = learnerStore.getSchoolLearners.filter(
    (learner) => learner._id == selectedStudents.value[0]
  );
  
  // Get the locked journeys of the learner
  const lockedJourneys = learnerDetails[0].settings.lockedJourneys;
  const selectedLockedJourney = lockedJourneys.catchup
    ? "catchup"
    : lockedJourneys.assessment
      ? "assessment"
      : "";

  // Get the assessment level of the learner
  const assessmentLevel = learnerDetails[0].assessmentStates.filter(
    (state) => state.subject.toLowerCase() === props.subject.toLowerCase()
  );

  // Clone the assessment state to avoid reference issues
  const assessmentLevelUpdate = assessmentLevel[0]
    ? JSON.parse(JSON.stringify(assessmentLevel[0]))
    : {};

  // Return the learner object
  let learner = {
    firstName: learnerDetails[0].firstName,
    lastName: learnerDetails[0].lastName,
    email: learnerDetails[0].email,
    password: "",
    studentNumber: learnerDetails[0].studentNumber,
    grade: learnerDetails[0].grade,
    lockedJourneys: selectedLockedJourney,
    country: learnerDetails[0]?.country,
    newAssessment: assessmentLevelUpdate,
    assessment: assessmentLevel[0],
    preferredLang: learnerDetails[0]?.preferredLang,
    classes: learnerDetails[0].classes,
    status: learnerDetails[0].status,
  };

  return learner as any;
});

// Function to check if two objects are deeply equal
const deepEqual = (changes: any, initialValues: any) => {
  if (changes == initialValues) return true;

  // Check if the objects are not objects or are null
  if (
    typeof changes !== "object" ||
    typeof initialValues !== "object" ||
    changes === null ||
    initialValues === null
  ) {
    return false;
  }

  // Get the keys of the objects
  const keys1 = Object.keys(changes);
  const keys2 = Object.keys(initialValues);

  // Check if the keys are not equal
  if (keys1.length !== keys2.length) return false;

  // Check if the keys are not equal
  for (let key of keys1) {
    if (!keys2.includes(key) || !deepEqual(changes[key], initialValues[key])) {
      return false;
    }
  }

  // Return true if the objects are deeply equal
  return true;
};

// Compute the assessment levels based on the subject
const getAssessmentLevels = computed(() => {
  // Define the assessment levels for Maths and English subjects
  const assessmentLevelMAth = [
    "MATHS_JUNIOR_PRIMARY",
    "MATHS_SENIOR_PRIMARY",
    "MATHS_SENIOR_PRIMARY_V2",
    "MATHS_JUNIOR_HIGH",
  ];

  const assessmentLevelEnglish = [
    "ENGLISH_JUNIOR_HIGH",
    "ENGLISH_SENIOR_PRIMARY",
  ];

  // Return the assessment levels based on the subject
  return props.subject == "maths"
    ? assessmentLevelMAth
    : assessmentLevelEnglish;
});

// Emit event setup


// Function to update the lockedJourneys state based on selected journey
const updateLockedJourneys = () => {
  lockedJourneys.value = {
    assessment: selectedJourney.value === "assessment" ? true : false,
    catchup: selectedJourney.value === "catchup" ? true : false,
  };
};

// Transform the assessment level text
const formatText = (input: string) => {
  // Remove "ENGLISH_" from the beginning
  let cleanedText = "";

  if (props.subject.toLocaleLowerCase() == "english") {
    // Step 1: Remove "ENGLISH_" from the beginning
    cleanedText = input.replace("ENGLISH_", "");
  }

  if (props.subject.toLocaleLowerCase() == "maths") {
    // Step 1: Remove "MATHS_" from the beginning
    cleanedText = input.replace("MATHS_", "");
  }

  // Step 2: Convert to lowercase
  cleanedText = cleanedText.toLowerCase();

  // Step 3: Replace underscores with spaces
  cleanedText = cleanedText.replace(/_/g, " ");

  // Step 4: Capitalize the first letter of each word
  cleanedText = cleanedText.replace(/\b\w/g, (char) => char.toUpperCase());

  return cleanedText;
};

// Cance single learner edit
const cancelSingleEdit = () => {
  if (schoolStore.currentSchool?._id)
    licenseStore.fetchLicenses(schoolStore.currentSchool?._id);
  singleEdit.value = false;
  showEditComplete.value = false;
  emit("closeUpdate");
};

const activeClass = ref(
  "p-[7px] text-blue-600 font-normal border-b-blue-600 border-b-[3px]"
);

const inactiveClass = ref(
  "p-[7px] text-gray-500 font-normal border-b-white border-b-[2px]"
);

const selectedClasses = ref<{ [key: string]: string }>({});
const previousSelectedClasses = ref<{ [key: string]: string }>({});
const subjects = computed(() => subjectStore.getSubjects);

// Compute classes for a given subject
const getClassesForSubject = (subjectName: string) => {
  const learnerDetails = learnerStore.getSchoolLearners.filter(
    (learner) => learner._id == selectedStudents.value[0]
  )[0];

  const grade = learnerDetails.grade;
  const subjectId = subjectStore.getSubjectIdByName(subjectName);

  if (!subjectId) {
    console.error(`Subject "${subjectName}" not found`);
    return ["None"];
  }

  let filteredClasses = schoolStore.getSchoolStructure?.classGroups.filter(
    (group) => group.gradeLevel === grade && group.subject === subjectId
  );

  // Get learnerDetails current classes for this subject
  const learnerClasses = learnerDetails.classes.filter(
    (cls) => cls.subject._id === subjectId
  );

  // Add the learnerClasses to the filteredClasses
  filteredClasses.push(...learnerClasses);
  
  // Remove duplicates
  filteredClasses = filteredClasses.filter(
    (group, index, self) =>
      index ===
      self.findIndex(
        (t) =>
          t._id === group._id &&
          t.name === group.name &&
          t.preferredLanguage === group.preferredLanguage
      )
  );

  return filteredClasses?.map((group) => ({
    name: group.name,
    id: group._id,
    preferredLanguage: group.preferredLanguage,
  }));
};

onMounted(() => {
  subjects.value.forEach((subject) => {
    const learnerClass = formData.value.classes?.find((cls) => {
      return cls.subject && String(cls.subject._id) === String(subject.id);
    });

    selectedClasses.value[subject.id] = learnerClass ? learnerClass._id : "";
    previousSelectedClasses.value[subject.id] = learnerClass
      ? learnerClass._id
      : "";
  });

  initialFormData.value = JSON.parse(JSON.stringify(formData.value));
});

const updateLearnerDetails = async () => {
  // Check if the password is valid
  if (
    formData.value.password.length > 0 &&
    formData.value.password.length < 6
  ) {
    validpassword.value = true;
    return;
  }
  if (!validEmail.value || validEmailExists.value === true) {
    return false;
  }

  //disable button once clicked
  disabledBtn.value = true;

  let changes = {} as any;

  // Merge selected classes into an array
  const mergedClasses = [
    selectedEnglishClass.value,
    selectedMathsClass.value,
  ].filter(Boolean);

  // Prepare the class update payload
  const learnerDetails = learnerStore.getSchoolLearners.filter(
    (learner) => learner._id == selectedStudents.value[0]
  )[0];

  const classUpdate = {
    classes: subjects.value.map((subject) => ({
      currentClass:
        learnerDetails.classes?.find((cls) => cls.subject._id === subject.id)
          ?._id || "",
      newClass: selectedClasses.value[subject.id],
    })),
  };

  // Loop through the form data and check for changes
  Object.keys(formData.value as any).forEach((key: any) => {
    if (!deepEqual(formData.value[key] as any, initialFormData.value[key])) {
      // Check if the key is assessment to make needed changes
      if (key == "newAssessment") {
        key = "assessmentUpgrades";
        changes[key] = [
          {
            _id: formData.value.assessment._id,
            type: formData.value.assessment.type,
            subject: formData.value.assessment.subject,
            newType: formData.value.newAssessment.type,
          },
        ];
      }
      // Check if the key is lockedJourneys to make needed changes
      else if (key == "lockedJourneys") {
        changes[key] = {
          assessment: formData.value[key] == "assessment" ? true : false,
          catchup: formData.value[key] == "catchup" ? true : false,
        };
      } else {
        // Add the changes to the changes object
        changes[key] = formData.value[key];
      }
    }
  });

  // Update classes if there's any changes
  classUpdate.classes.forEach((classItem) => {
    if (
      classItem.currentClass != classItem.newClass ||
      classItem.newClass != ""
    ) {
      changes = { ...classUpdate, ...changes };
    }
  });

  // Check if there are no changes and close the modal without hitting the endpoint
  if (Object.keys(changes).length === 0) {
    //Hide modal without hitting the endpoint
    cancelSingleEdit();
    return;
  }

  //Perform bulk update through the store updateLearner(learnerId:any ,updateClassDetails: any)
  const request = await learnerStore.updateLearner(
    selectedStudents.value,
    changes
  );

  if (request) {
    //if a new class was assigned and the current class was "" add license for each new class subject
    if (classUpdate.classes.some((cls) => cls.currentClass === "")) {
      const productIds = classUpdate.classes
        .filter((cls) => cls.currentClass === "" && cls.newClass !== "")
        .map((cls) => {
          const classGroup = filterStore.allClassGroups.find(
            (group) => group._id === cls.newClass
          );
          if (classGroup) {
            const product = licenseStore.getLicense?.products.find(
              (product) => product.product.subject === classGroup.subject
            );
            return product?._id;
          }
          return null;
        })
        .filter((id) => id !== null);
      await licenseStore.assignLicenses(selectedStudents.value[0], productIds);
    }
    //if the status is active and the school has a wondeId, assign licenses
    if (changes?.status == "active" && schoolStore.currentSchool?.wondeId) {
      const productIds = schoolStore.currentSchool.schoolLicense.products.map(
        (product) => product._id
      );
      await licenseStore.assignLicenses(selectedStudents.value[0], productIds);
    }
  }

  // Show the response modal
  if (request) {
    response.value = "success";
    singleEdit.value = false;
    showEditComplete.value = true;
  } else {
    response.value = "failed";
    showEditComplete.value = true;
  }
};

const handleClassChange = (
  subjectId: string,
  newClassId: string,
  previousClassId: string
) => {
  if (newClassId && !previousClassId) {
    //if the previous value was null and the new value is not null, inscrease the license count
    const license = licenseStore.getLicense;
    const licenseProduct = license?.products.find(
      (product) => product.product.subject === subjectId
    );
    if (licenseProduct) {
      licenseStore.incrementSchoolLicenseSeatsUsed(licenseProduct._id);
    }
  } else if (previousClassId && !newClassId) {
    //if the previous value was not null and the new value is null, decrease the license count
    const license = licenseStore.getLicense;
    const licenseProduct = license?.products.find(
      (product) => product.product.subject === subjectId
    );
    if (licenseProduct) {
      licenseStore.decrementSchoolLicenseSeatsUsed(licenseProduct._id);
    }
  }
  if (licenseStore.isSubjectLicenseSeatsExceeded(subjectId, newClassId)) {
    disabledBtn.value = true;
  } else {
    disabledBtn.value = false;
  }
  previousSelectedClasses.value[subjectId] = newClassId;
};

const validateEmail = async () => {
  if (initialFormData.value.email === formData.value.email) {
    validEmail.value = true;
    return;
  }
  try {
    let response = await learnerStore.validateEmail(formData.value.email);
    if (response === true) {
      validEmail.value = true; //email already exists
      validEmailExists.value = true;
    } else {
      validEmail.value = true;
      validEmailExists.value = false;
    }
  } catch (error) {
    validEmail.value = false; //invalid email
    validEmailExists.value = false;
  }
};

const isValidAssessmentLevel = ref(true);

const validateAssessmentLevel = () => {
  const currentType = formData.value.assessment?.type;
  const newType = formData.value.newAssessment.type;
  isValidAssessmentLevel.value = assessmentLevelValidation(currentType, newType);
  if (!isValidAssessmentLevel.value) {
    disabledBtn.value = true;
  } else {
    disabledBtn.value = false;
  }
};

const assessmentLevelValidation = (currentType, newType) => {
  const assessmentLevels = {
    "MATHS_JUNIOR_PRIMARY": 0,
    "MATHS_SENIOR_PRIMARY": 1,
    "MATHS_SENIOR_PRIMARY_V2": 1,
    "MATHS_JUNIOR_HIGH": 2,
    "ENGLISH_SENIOR_PRIMARY": 0,
    "ENGLISH_JUNIOR_HIGH": 1
  };
  if (Math.abs(assessmentLevels[currentType] - assessmentLevels[newType]) > 1) {
    return false;
  }
  return true;
}


return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-2xl',
      open: singleEdit.value,
      onLocalModalOpen: cancelSingleEdit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("update_student.title")), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(SchoolLicenseComponent, {
                showAllLicenses: "true",
                layoutType: "horizontal"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: _normalizeClass(activeTab.value == 'personal' ? activeClass.value : inactiveClass.value
            ),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'personal'))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("update_student.personal.personal")), 1)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(activeTab.value == 'settings' ? activeClass.value : inactiveClass.value
            ),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'settings'))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("update_student.settings.settings")), 1)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(activeTab.value == 'subject' ? activeClass.value : inactiveClass.value
            ),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'subject'))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("update_student.subject.subject")), 1)
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (activeTab.value == 'personal')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(updateLearnerDetails, ["prevent"]),
                    id: "update-learner-personal",
                    class: "flex flex-col gap-5"
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("update_student.personal.first_name")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "firstName",
                        id: "firstName",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.firstName) = $event)),
                        class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 w-[60%] focus:outline-none focus:ring-2 focus:ring-blue-500 text-base font-normal text-gray-900"
                      }, null, 512), [
                        [_vModelText, formData.value.firstName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("update_student.personal.last_name")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "lastName",
                        id: "lastName",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.lastName) = $event)),
                        class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 w-[60%] focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                      }, null, 512), [
                        [_vModelText, formData.value.lastName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("update_student.personal.email")), 1),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          name: "email",
                          id: "email",
                          onBlur: validateEmail,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.email) = $event)),
                          class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                        }, null, 544), [
                          [_vModelText, formData.value.email]
                        ]),
                        (!validEmail.value)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_18, _toDisplayString(_ctx.$t("update_student.personal.email_invalid")), 1))
                          : _createCommentVNode("", true),
                        (validEmailExists.value)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_19, _toDisplayString(_ctx.$t("update_student.personal.email_exists")), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("update_student.personal.password")), 1),
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          name: "password",
                          id: "password",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.password) = $event)),
                          class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 w-[100%] focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                        }, null, 512), [
                          [_vModelText, formData.value.password]
                        ]),
                        (validpassword.value)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_23, _toDisplayString(_ctx.$t("update_student.personal.message")), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("update_student.personal.student_number")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "studentNumber",
                        id: "studentNumber",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.studentNumber) = $event)),
                        class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 w-[60%] focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                      }, null, 512), [
                        [_vModelText, formData.value.studentNumber]
                      ])
                    ])
                  ], 40, _hoisted_10)
                ]))
              : _createCommentVNode("", true),
            (activeTab.value == 'settings')
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(updateLearnerDetails, ["prevent"]),
                    id: "update-learner-settings",
                    class: "flex flex-col gap-5"
                  }, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("update_student.settings.grade")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "grade",
                        id: "grade",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.grade) = $event)),
                        class: "p-2 w-[60%] border border-gray-300 rounded-lg shadow-box focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                      }, null, 512), [
                        [_vModelText, formData.value.grade]
                      ])
                    ]),
                    (_unref(userStore).isInternalAdmin || _unref(userStore).isSchoolGroupAdmin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("update_student.settings.status")), 1),
                          _withDirectives(_createElementVNode("select", {
                            name: "status",
                            id: "status",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.status) = $event)),
                            class: "w-[60%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                          }, _hoisted_35, 512), [
                            [_vModelSelect, formData.value.status]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(userStore).isClassGroupAdmin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("update_student.settings.locked_journeys")), 1),
                          _withDirectives(_createElementVNode("select", {
                            name: "lockedJourneys",
                            id: "lockedJourneys",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.lockedJourneys) = $event)),
                            onChange: updateLockedJourneys,
                            class: "w-[60%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                          }, [
                            _createElementVNode("option", _hoisted_38, _toDisplayString(_ctx.$t("update_student.settings.catchup")), 1),
                            _createElementVNode("option", _hoisted_39, _toDisplayString(_ctx.$t("update_student.settings.assessment")), 1),
                            _createElementVNode("option", _hoisted_40, _toDisplayString(_ctx.$t("update_student.settings.none")), 1)
                          ], 544), [
                            [_vModelSelect, formData.value.lockedJourneys]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("update_student.settings.country")), 1),
                      _withDirectives(_createElementVNode("input", {
                        name: "country",
                        id: "country",
                        readonly: "",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.country) = $event)),
                        class: "cursor-not-allowed w-[60%] border border-gray-300 shadow-box px-[14px] py-[10px] bg-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                      }, null, 512), [
                        [_vModelText, formData.value.country]
                      ])
                    ])
                  ], 40, _hoisted_27)
                ]))
              : _createCommentVNode("", true),
            (activeTab.value == 'subject')
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(updateLearnerDetails, ["prevent"]),
                    id: "update-learner-settings",
                    class: "flex flex-col gap-5"
                  }, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("h3", _hoisted_46, _toDisplayString(_ctx.$t("update_student.subject.class")), 1),
                      _createElementVNode("div", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjects.value, (subject) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: subject.id
                          }, [
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("label", {
                                for: subject.name + 'Class',
                                class: "text-sm font-medium text-gray-700"
                              }, _toDisplayString(subject.name), 9, _hoisted_49),
                              _withDirectives(_createElementVNode("select", {
                                id: subject.name + 'Class',
                                class: "w-[60%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900",
                                "onUpdate:modelValue": ($event: any) => ((selectedClasses.value[subject.id]) = $event),
                                onChange: ($event: any) => (
                        handleClassChange(
                          subject.id,
                          selectedClasses.value[subject.id],
                          previousSelectedClasses.value[subject.id]
                        )
                        )
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getClassesForSubject(
                        subject.name
                      ), (classGroup) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: classGroup.id,
                                    value: classGroup.id
                                  }, _toDisplayString(classGroup.name), 9, _hoisted_51))
                                }), 128))
                              ], 40, _hoisted_50), [
                                [_vModelSelect, selectedClasses.value[subject.id]]
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    (!_unref(userStore).isClassGroupAdmin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("update_student.subject.assessment_level")), 1),
                          _withDirectives(_createElementVNode("select", {
                            id: "assessmentLevel",
                            class: "w-[60%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-[#101828]",
                            placeholder: "select",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.newAssessment.type) = $event)),
                            onChange: validateAssessmentLevel
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAssessmentLevels.value, (classGroup) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: classGroup,
                                value: classGroup
                              }, _toDisplayString(formatText(classGroup)), 9, _hoisted_54))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, formData.value.newAssessment.type]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!isValidAssessmentLevel.value)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_55, _toDisplayString(_ctx.$t("update_student.subject.assessment_level_validation")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("update_student.subject.language")), 1),
                      _withDirectives(_createElementVNode("select", {
                        id: "english",
                        class: "w-[60%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900",
                        placeholder: "select",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.preferredLang) = $event))
                      }, _hoisted_62, 512), [
                        [_vModelSelect, formData.value.preferredLang]
                      ])
                    ])
                  ], 40, _hoisted_44)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("button", {
                class: "w-1/2 font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8",
                onClick: cancelSingleEdit
              }, _toDisplayString(_ctx.$t("bulk_learner_edit_component.btn_cancel")), 1),
              _createElementVNode("button", {
                disabled: disabledBtn.value,
                class: _normalizeClass([
            'w-1/2 font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white',
            selectedStudents.value.length === 0
              ? 'bg-gray-300 cursor-not-allowed'
              : '',
            disabledBtn.value ? 'cursor-wait' : 'cursor-pointer'                      
          ]),
                onClick: updateLearnerDetails
              }, [
                (_unref(learnerStore).loader.learner)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                      _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                      _createTextVNode(" " + _toDisplayString(_unref(learnerStore).loadingMessage), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.$t("bulk_learner_edit_component.btn_save")), 1))
              ], 10, _hoisted_65)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      widthClass: 'max-w-lg',
      open: showEditComplete.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", null, [
                (response.value == 'success')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-green-tick',
                        title: 'rl green tick',
                        "aria-hidden": "true"
                      })
                    ]))
                  : _createCommentVNode("", true),
                (response.value == 'failed')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_72, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-red-fail',
                        title: 'rl red fail',
                        "aria-hidden": "true"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (response.value == 'success')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_73, _toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.header")), 1))
                : _createCommentVNode("", true),
              (response.value == 'failed')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_74, _toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.failed_header")), 1))
                : _createCommentVNode("", true),
              (response.value == 'success')
                ? (_openBlock(), _createElementBlock("p", _hoisted_75, [
                    _createElementVNode("span", _hoisted_76, _toDisplayString(formData.value.lastName) + " " + _toDisplayString(formData.value.firstName), 1),
                    _createTextVNode(_toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.success_update")), 1)
                  ]))
                : _createCommentVNode("", true),
              (response.value == 'failed')
                ? (_openBlock(), _createElementBlock("p", _hoisted_77, [
                    _createTextVNode(_toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.changes")) + " ", 1),
                    _createElementVNode("span", _hoisted_78, _toDisplayString(formData.value.lastName) + " " + _toDisplayString(formData.value.firstName), 1),
                    _createTextVNode(_toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.not_successful")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("button", {
                  class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-2 w-full focus:outline-none",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => ((showEditComplete.value = false), cancelSingleEdit()))
                }, _toDisplayString(_ctx.$t("student_table_view.confirm_modal.btn_edit")), 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})